<template>
  <svg :class="`svg-icon ${className}`" aria-hidden="true">
    <use :xlink:href="`#lni-${iconName}`" :class="useClass" />
  </svg>
</template>

<script>
export default {
  name: "svgIcon",
  props: {
    className: {
      type: String,
      required: true,
    },
    iconName: {
      type: String,
      required: true,
    },
    useClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    // iconName() {
    //   return `#lni-${this.name}`;
    // },
    // svgClass() {
    //   if (this.className) {
    //     return "svg-icon " + this.className;
    //   } else {
    //     return "svg-icon";
    //   }
    // },
  },
  mounted() {
    // console.log(111, this.name);
  },
};
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon.vue